exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-container {\n    background: linear-gradient(to right bottom, rgba(var(--main-color), .5), rgba(var(--main-color), 1), rgba(var(--main-color), 1), rgba(var(--main-color), .5));\n    font-size: 1em;\n    min-width: 18em;\n    max-width: 22em;\n    --logo-radius: .3em;\n    border-radius: var(--logo-radius);\n}\n\n.logo {\n    border: white .2em solid;\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 700;\n    color: #fff;\n    letter-spacing: .2em;\n    border-radius: var(--logo-radius);\n    padding: .8em .4em;\n    text-transform: uppercase;\n    line-height: 2em;\n    text-align: center;\n}", ""]);

// exports
